import Vue from 'vue';
export default Vue.extend({
  data: function () {
    return {};
  },
  computed: {
    admin() {
      return this.params.data.role_name == 'admin';
    },
    member() {
      return this.params.data.role_name == 'member';
    },
  },
  beforeMount() {},
  mounted() {},
  methods: {
    btnClickedHandler(params) {
      this.params.clicked(params.data);
    },
  },
  template: `
  <div>
    <i v-show="admin" @click="btnClickedHandler(params)" class="fas text-success fa-check" :title="$t('demote-to-member')" style="cursor: pointer;"></i>
    <i v-show="member" @click="btnClickedHandler(params)" class="fas text-danger fa-times" :title="$t('promote-to-admin')" style="cursor: pointer;"></i>
  </div>
    `,
});
